import { render, staticRenderFns } from "./trade-statistics.vue?vue&type=template&id=4e655ada&"
import script from "./trade-statistics.vue?vue&type=script&lang=js&"
export * from "./trade-statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports